export interface ChamadaManualParams {
  calls: number;
  manualCall: boolean;
  isAdmin: boolean;
  unitCode: number | string;
}

// A unidade 1005 tem liberacao propria, anterior a esta regra, e foi mantida de proposito.
// unitCode chega como string em runtime (localStorage grava via String()); comparar por numero.
export function podeChamarManual(p: ChamadaManualParams): boolean {
  return (p.calls < 3 && (p.manualCall || p.isAdmin)) || Number(p.unitCode) === 1005;
}
